export default "__VITE_ASSET__CE0cR7Nm__"